import notEmpty from '../../foundation/js/validators/notEmptyValidator'
import isEmail from '../../foundation/js/validators/emailValidator'
import isInOptions from '../../foundation/js/validators/optionsValidator'

import setup from '../../foundation/js/checkoutFormsSetup'

const formConfigGenerator = function(store,fields,countryList){
    
    if(!fields){
        console.error("fields are missing in delivery info",fields)
        fields = {}
    }

    const getLabel = (labelRequested) => {
        return store.getters['labels/getLabel'](labelRequested)
    }
    const formConfig = [
        {
            label: getLabel('full_name'),
            name: 'name',
            required: true,
            type: 'text',
            value: fields.name || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('company_name'),
            name: 'companyName',
            required: false,
            type: 'text',
            value: fields.companyName || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('address'),
            name: 'address',
            required: true,
            type: 'text',
            value: fields.address || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('address2'),
            name: 'address2',
            required: false,
            type: 'text',
            value: fields.address2 || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('zip_code'),
            name: 'zipCode',
            required: true,
            type: 'text',
            value: fields.zipCode || '',
            valid: false,
            validator: notEmpty,
            small: true 
        },
        {
            label: getLabel('city'),
            name: 'city',
            required: true,
            type: 'text',
            value: fields.city || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('country'),
            name: 'country',
            required: true,
            type: 'select',
            options: countryList,
            value: fields.country || '',
            valid: false,
            validator: isInOptions,
            small: false 
        },
        {
            label: getLabel('phone'),
            name: 'phoneNumber',
            required: true,
            type: 'text',
            value: fields.phoneNumber || '',
            valid: false,
            validator: notEmpty,
            small: false 
        },
        {
            label: getLabel('email'),
            name: 'emailAddress',
            required: true,
            type: 'text',
            value: fields.emailAddress || '',
            valid: false,
            validator: isEmail,
            small: false 
        },
        {
            label: getLabel('repeat_email'),
            name: 'emailAddress2',
            required: true,
            compareTo: 'emailAddress',
            type: 'text',
            value: fields.emailAddress2 ||'',
            valid: false,
            validator: isEmail,
            small: false 
        }
    ]
    return formConfig
}



export default {
    name: "DeliveryInfo",
    props:{
        disabled:{
            type: Boolean
        },
        fields: {
            type:Object,
            default: {}
        },
        countryList:{
            Type: Array
        },
        formName:{
            type: String
        }
    },
    setup: setup.bind(null,formConfigGenerator,null)
}